import { List, ListItem, ListItemText, Box, Typography, Divider, Alert, ListItemAvatar, Avatar, IconButton, Button, ListSubheader } from "@mui/material";
import { PictureAsPdf, Verified, FactCheck } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { createFile } from "../../features/download/downloadSlice";
import { EventsChart, ChipYears } from "../Tools";
import moment from "moment";

const Items = ({ clearResult }) => {
    const { events, user, total, hours, dataChart, years } = useSelector(state => state.search);
    const { isSending } = useSelector(state => state.progress);
    const dispatch = useDispatch();
    return(
        <>  
            <Box
                sx={{ mt: '1em', display: 'flex', flexDirection: 'column', alignItems: 'center' }}
            >
                <Avatar sx={{ bgcolor: 'green', mb: '1em' }} ><FactCheck /></Avatar>
                <Typography variant="h5" gutterBottom>{ user?.codigo }</Typography>
                <Typography variant="h5" gutterBottom>{user?.nombre}</Typography>
            </Box>
            <Button variant="outlined" color="info" onClick={() => dispatch(clearResult())} sx={{ mb: '2em' }}>Nueva busqueda</Button> 
            { total ? 
                <> 
                    <Box display={'flex'} sx={{ justifyContent: 'space-between', mb: '1em', mt: '1em' }}>
                        <Alert severity="success">Eventos: <b>{total}</b></Alert>
                        <Alert severity="info">Horas: <b>{hours}</b></Alert>
                    </Box>
                    <ChipYears years={years} />
                    <EventsChart data={dataChart} />
                    <List
                        sx={{ mt: '1em' }}
                        subheader={
                            <ListSubheader component={'div'}>
                                Da click en el botón 
                                    <IconButton disabled> 
                                        <PictureAsPdf /> 
                                    </IconButton> 
                                para descagar contancia del evento.
                            </ListSubheader>
                        }
                    >
                        { events.map(({ id, tipo, nombre, lugar, fecha, constancy }, i) => (
                            <div key={i}>
                                <ListItem
                                    secondaryAction={
                                        constancy ?
                                            <IconButton 
                                                color="primary"
                                                disabled={isSending}
                                                onClick={() => createFile('constancy', { idUsuario: user.id, idEvento: id }, dispatch)}
                                                title="Descargar Constancia"
                                            >
                                                <PictureAsPdf />
                                            </IconButton>
                                        : null
                                    }
                                >
                                    <ListItemAvatar>
                                        <Avatar sx={{ bgcolor: 'green' }}> <Verified /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={tipo}
                                        secondary={
                                            <>
                                                <Typography
                                                    sx={{ display: 'inline' }}
                                                    component="span"
                                                    variant="body2"
                                                    color="text.primary"
                                                >
                                                    {nombre}
                                                </Typography>
                                                <br />{`${lugar}  —  ${moment(fecha).format('LL')}`}
                                            </>}
                                    />
                                </ListItem>
                                <Divider variant="inset" component={'li'} />
                            </div>
                        )) }
                    </List>
                </> 
            : <Alert severity="error">No se encontraron registros de asistencia a eventos!</Alert> }
        </>
    )
}

export default Items;